import EcgLoader from './EcgLoader';

export default EcgLoader;



// WEBPACK FOOTER //
// ./src/views/components/EcgLoader/index.js